import React from 'react';
import './Lightbox.css';
import { Link } from 'react-router-dom';
import { baseurl } from '../../general';

export default ({ setShowBox, hash, single }) => (
  <div className={single ? 'lightbox_links_single' : 'lightbox_links'}>
    {single || <p onClick={() => setShowBox(true)} className="lightbox_link">Delete</p>}
    <p className="lightbox_link"><a href={`mailto:?subject=Lightbox sharing - Diva Models&body=https://divamodels.com/lightbox/${hash}`}>Email</a></p>
    <p className="lightbox_link"><a href={`${baseurl}pdf_lightbox/${hash}`}>PDF</a></p>
    <p className="lightbox_link"><Link to={`lightbox/${hash}`}>Link</Link></p>
  </div>
);
